var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M208.699,159.899c-1.815-2.002-4.144-3.058-6.733-3.058c-2.118,0-7.314,0.733-9.839,7.515c-0.636,1.706-0.82,2.614-1.678,2.522 c-1.454-0.144-7.114-6.19-8.964-15.069l-4.592-21.461c3.628-5.878,7.358-10.414,11.078-13.491 c1.998-1.632,4.281-2.496,7.045-2.646c7.058-0.481,9.626-1.369,11.36-2.588c2.862-2.063,4.435-5.047,4.435-8.403 c0-2.953-1.117-5.585-3.238-7.613c-2.046-1.959-4.775-2.993-7.881-2.993c-4.566,0-9.693,2.113-15.678,6.457 c-3.534,2.568-7.28,6.301-11.325,11.306c-1.315-4.908-2.44-7.195-3.277-8.562c-2.583-4.261-6.779-4.261-8.159-4.261l-1.504,0.024 l-42.636,1.006l2.4-10.187c1.532-6.647,3.543-11.907,5.968-15.633c1.18-1.813,2.986-3.974,4.881-3.974 c0.716,0,2.131,0.117,4.777,0.666c7.36,1.591,10.111,1.774,11.543,1.774c3.16,0,5.939-1.056,8.042-3.055 c2.176-2.07,3.325-4.779,3.325-7.832c0-2.387-0.784-5.839-4.524-8.736c-2.583-2-6.126-3.014-10.529-3.014 c-6.601,0-13.596,2.111-20.797,6.272c-7.145,4.129-13.021,9.837-17.461,16.967c-3.894,6.252-7.269,15.03-10.277,26.751h-18.79 l-4.141,16.338h18.845l-14.32,57.568c-2.966,11.92-5.138,14.853-5.732,15.469c-1.619,1.673-4.958,2.024-7.474,2.024 c-3.114,0-6.433-0.224-9.896-0.668c-2.379-0.29-4.191-0.433-5.534-0.433c-3.475,0-6.333,0.903-8.492,2.679 c-2.407,1.978-3.732,4.836-3.732,8.05c0,2.511,0.814,6.122,4.697,9.056c2.653,1.998,6.27,3.012,10.755,3.012 c11.228,0,21.693-4.461,31.106-13.256c9.153-8.555,15.857-21.115,19.931-37.363l11.321-46.133l38.612,0.655l4.152,17.835 l-8.461,12.485c-1.524,2.237-3.795,4.997-6.768,8.216c-1.554,1.702-2.586,2.638-3.184,3.125c-2.435-2.975-5.197-4.485-8.2-4.485 c-2.821,0-5.384,1.156-7.404,3.338c-1.917,2.065-2.929,4.651-2.929,7.471c0,3.386,1.449,6.4,4.189,8.712 c2.511,2.12,5.613,3.197,9.215,3.197c4.466,0,9.036-1.704,13.587-5.064c3.798-2.81,8.69-8.374,14.938-17.001 c4.015,11.545,9.709,18.967,12.422,22.066c4.279,4.892,11.191,7.807,18.488,7.807c6.194,0,9.702-2.594,12.795-4.886l0.274-0.202 c5.413-4.004,6.549-8.409,6.549-11.408C211.28,164.134,210.387,161.755,208.699,159.899z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 220,
    height: 220
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputed);
export default __webpack_public_path__ + "static/media/computed.8d0e31648946abd1060b6bdb8033474a.svg";
export { ForwardRef as ReactComponent };